import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import EditCutoverplanResponsibleTab from '@/components/Tabs/EditCutoverplanResponsibleTab.vue';
import EditCutoverplanDefaultTab from '@/components/Tabs/EditCutoverplanDefaultTab.vue';
import EditCutoverplanPhaseTab from '@/components/Tabs/EditCutoverplanPhaseTab.vue';
import EditCutoverplanModuleTab from '@/components/Tabs/EditCutoverplanModuleTab.vue';
import EditCutoverplanEnvironmentsTab from '@/components/Tabs/EditCutoverplanEnvironmentsTab.vue';
import EditCutoverplanAttributeTab from '@/components/Tabs/EditCutoverplanAttributeTab.vue';
import EditCutoverplanIssuesTab from '@/components/Tabs/EditCutoverplanIssuesTab.vue';
import EditCutoverplanChangelogTab from '@/components/Tabs/EditCutoverplanChangelogTab.vue';
import WaveMatrixView from '@/views/WaveMatrixView.vue';
import ModuleView from '@/views/ModulePage/index.vue';
import AttributesView from '../views/AttributesView.vue';
import BlankRouter from '../views/BlankRouter.vue';
import TimelineView from '../views/TimelineView.vue';
import Waves from '../views/WavesView.vue';
import Responsibles from '../views/ResponsiblesView.vue';
import EditCutoverplanView from '../views/EditCutoverplanView.vue';
import EnvironmentsView from '../views/EnvironmentsView.vue';
import ChangelogView from '../views/ChangelogView.vue';
import PhaseView from '../views/PhaseView.vue';
import MatrixView from '../views/MatrixView.vue';
import ModulesListView from '../views/ModulesListView.vue';
import UserView from '../views/UserView.vue';
import UsersView from '../views/UsersView.vue';
import CutoverplansListView from '../views/CutoverplansListView.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/timeline',
    name: 'Timelines',
    component: TimelineView,
    meta: { breadCrumb: 'Timeline' }
  },
  {
    path: '/matrix',
    name: 'Matrix',
    component: MatrixView,
    meta: { breadCrumb: 'Matrix' }
  },
  {
    path: '/blueprints',
    component: BlankRouter,
    meta: { breadCrumb: 'Blueprints' },
    children: [
      {
        path: '',
        name: 'ModulesListView',
        component: ModulesListView
      },
      {
        path: ':module_id',
        name: 'EditBlueprintView',
        component: ModuleView,
        meta: { breadCrumb: '[module]' }
      }
    ]
  },
  {
    path: '/',
    component: BlankRouter,
    meta: { breadCrumb: 'Cutoverpläne' },
    children: [
      {
        path: '',
        name: 'CutoverplansListView',
        component: CutoverplansListView
      },
      {
        path: 'cutoverplan/:cutoverplan_id/',
        component: BlankRouter,
        meta: {
          breadCrumb: '[cutoverplan]'
        },
        children: [
          {
            path: '',
            component: EditCutoverplanView,
            children: [
              {
                path: '',
                name: 'EditCutoverplanDefaultTab',
                component: EditCutoverplanDefaultTab
              },
              {
                path: 'responsibles',
                name: 'EditCutoverplanResponsibleTab',
                component: EditCutoverplanResponsibleTab,
                meta: { breadCrumb: 'Ansprechpartner' }
              },
              {
                path: 'phases',
                name: 'EditCutoverplanPhaseTab',
                component: EditCutoverplanPhaseTab,
                meta: { breadCrumb: 'Phasen' }
              },
              {
                path: 'environments',
                name: 'EditCutoverplanEnvironmentTab',
                component: EditCutoverplanEnvironmentsTab,
                meta: { breadCrumb: 'Umgebungen' }
              },
              {
                path: 'module',
                name: 'EditCutoverplanModuleTab',
                component: EditCutoverplanModuleTab,
                meta: { breadCrumb: 'Module' }
              },
              {
                path: 'attributes',
                name: 'EditCutoverplanAttributeTab',
                component: EditCutoverplanAttributeTab,
                meta: { breadCrumb: 'Attribute' }
              },
              {
                path: 'issues',
                name: 'EditCutoverplanIssuesTab',
                component: EditCutoverplanIssuesTab,
                meta: { breadCrumb: 'Open Issues' }
              },
              {
                path: 'changelog',
                name: 'EditCutoverplanChangelogTab',
                component: EditCutoverplanChangelogTab,
                meta: { breadCrumb: 'Changelog' }
              }
            ]
          },
          {
            path: 'module',
            name: 'CutoverplanModuleList',
            children: [
              {
                path: ':module_id',
                name: 'ModuleView',
                component: ModuleView,
                meta: {
                  breadCrumb: '[module]'
                }
              }
            ],
            component: BlankRouter,
            meta: { breadCrumb: 'Module' }
          }
        ]
      }
    ]
  },
  {
    path: '/environment',
    name: 'Environments',
    component: EnvironmentsView,
    meta: { breadCrumb: 'Umgebungen' }
  },
  {
    path: '/wave',
    component: BlankRouter,
    meta: { breadCrumb: 'Wellen' },
    children: [
      {
        path: '',
        name: 'Waves',
        component: Waves
      },
      {
        path: ':wave_id',
        name: 'Wave',
        component: BlankRouter,
        meta: {
          breadCrumb: '[wave]'
        },
        children: [
          {
            path: 'appointments',
            name: 'WaveMatrixView',
            component: WaveMatrixView,
            meta: {
              breadCrumb: 'Termine'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/responsible',
    name: 'Responsibles',
    component: Responsibles,
    meta: { breadCrumb: 'Ansprechpartner' }
  },
  {
    path: '/changelog',
    name: 'Changelog',
    component: ChangelogView,
    meta: { breadCrumb: 'Changelog' }
  },
  {
    path: '/phase',
    name: 'Phase',
    component: PhaseView,
    meta: { breadCrumb: 'Phase' }
  },
  {
    path: '/user',
    name: 'User',
    component: UserView,
    meta: { breadCrumb: '[username]' }
  },
  {
    path: '/users',
    name: 'Users',
    component: UsersView,
    meta: { breadCrumb: 'Benutzer' }
  },
  {
    path: '/attributes',
    name: 'Attributes',
    component: AttributesView,
    meta: { breadCrumb: 'Attribute' }
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
